module.exports = __webpack_public_path__ + "img/google.c87bd5c5.png";